import {Component, Input, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, CallCenterActionService} from '../_services';
import {CrudSavePopupComponent} from '../_directives';
import {FormBuilder, Validators} from '@angular/forms';
import {
  CallCenterAction,
  DelayActionType,
  DelayActionTypeLabels
} from "../_models";
import {tinyMCESingleLine, tinyMCETTextOnly} from '../_helpers';

@Component({
  moduleId: module.id.toString(),
  selector: 'call-center-action-form',
  templateUrl: './call-center-action-form.component.html'
})
export class CallCenterActionFormComponent extends CrudSavePopupComponent implements OnInit {
  action: CallCenterAction;
  @Input() contentVariables = null;

  constructor(protected router: Router,
              protected location: Location,
              protected route: ActivatedRoute,
              protected formBuilder: FormBuilder,
              protected actionService: CallCenterActionService,
              protected alertService: AlertService
  ) {
    super(router, location, route, actionService, alertService);
    this.objectName = 'Call Center Action';
  }

  ngOnInit() {
    this.setForm(this.formBuilder.group({
      name: [null, Validators.required],
      prevent_action: [false],
      action_delay: [24, [Validators.required, Validators.min(1)]],
      delay_type: [DelayActionType.Normal, Validators.required],
      min_price: [0, [Validators.required, Validators.min(0)]],
      contact_popup: [null],
      after_hours_popup: [null],
      subject: [null],
    }));

    super.ngOnInit();
  }

  protected onInputDataChanged() {
    this.action = this.inputData;
    this.isNew = !this.action || !this.action.id;
  }

  getDelayActionTypes() {
    let types = [];

    DelayActionTypeLabels.forEach((value, index) => {
      types.push({id: index, label: value});
    });

    return types;
  }

  protected readonly editorSetupCallback = tinyMCESingleLine;
  protected readonly editorInitCallback = tinyMCETTextOnly;
}
